// extracted by mini-css-extract-plugin
module.exports = {"svg-icon":"_668cf1","svg-icon_loader":"_040f70","rotator":"fe547c","dash":"a10591"};